<template>
  <div class="wrap sunhome-wrap personal-wrap flex-column">
    <mu-infinite-scroll :loading="loadShow" loadingText="拼命加载中" class="load" v-if="loadShow" />
    <div class="flex-item" v-if="!loadShow">
      <div>
        <div class="orders-list detail">
          <div class="orders-list-item">
            <div class="grid-tip" >
              <p class="wid60  fl ellipsis">订单号:<span class="black">{{orderId}}</span></p>
              <!-- <p class="wid40  ellipsis">{{memOrderDetailMsg.orderTime}}</p> -->
            </div>
            <div class="goods-content">
              <!-- <div class="goods-box" v-for="(listShop,shopIndex) in memOrderDetailMsg.goodsOrderMsgs">
                <imgs :width="240" :imagePath="listShop.imagePath && listShop.imagePath.imagePath"></imgs>
              </div> -->
              <div class="banner-recommend">
                <swiper :options="comSwiperOption" ref="mySwiper2">
                  <!-- 这部分放你要渲染的那些内容 -->
                  <swiper-slide v-for="(item,index) in memOrderDetailMsg" :key="index">
                    <div class="img-box" @click="viewGoodsDetail(item)">
                      <div class="img">
                        <imgs :width="250" :height="250" :imagePath="item.imagePath && item.imagePath.imagePath"></imgs>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
            <!-- <mu-list>
              <myOrdersItem :width="150" :height="150" v-for="(listShop,shopIndex) in memOrderDetailMsg.goodsOrderMsgs" :cartitem="listShop" :key="shopIndex" :isRightTriggle="'true'">
              </myOrdersItem>
            </mu-list> -->
            <div class="text-content">
              <textarea maxlength="200"  v-model="commDesc" placeholder="输入分享内容…"></textarea>
            </div>
            <div class="img-content">
              <!-- 图片列表 -->
              <div class="img-item" v-for='item in file'>
                <div class="filter"></div>
                <div class="verticalM"><img :src="item.fileName" class="verticalM-box"></div>
                <label class="delete" @click="deletefile(item.fileId)"></label>
              </div>
              <!-- 新增图片 -->
              <div class="img-item add"><input type="file" class="file-button"  @change="selimg()" ref="albumImg"  accept="image/*" value=""></div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-box">
      <div class="bottom-full-button"> 
        <mu-raised-button label="提交" fullWidth primary @click="submit()" />
      </div>
    </div>
    <mu-toast v-if="toast.isShow" :message="toast.messageTip" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
import imgs from '@components/image/image';
import { mapActions } from 'vuex';
import { storage } from "@common/utils/util.js";
import util from '@common/utils/util';
import Constant from '@/Constant';
export default {
  data() {
    return {
      actionUrl: Constant.uploadBaseUrl + "/apps", //提交URL
      loadShow: true, //加载
      toast:{
          isShow:false,
          messageTip:'',
      },
      stOrderId: this.$route.query.stOrderId, //店铺订单id
      orderId: this.$route.query.orderId, //店铺订单id
      commDesc:'',
      file:[],
      comSwiperOption: {
        slidesPerView: 3.5,
        slidesPerGroup: 2,
        autoplay: 10000,
        loop: false,
        autoplayDisableOnInteraction: false,
      },
    }
  },
  methods: {
    ...mapActions({
      getMemOrderDetail: 'getMemOrderDetail', //获取会员订单详情
      listOrderGoodsMsgByOrderId:'listOrderGoodsMsgByOrderId',
      submitShareData:'submitShareData'

    }),
    showTipMessage(isShow,msg){
        this.toast.isShow = isShow;
        this.toast.messageTip =msg;
        setTimeout(() => { 
          this.toast.isShow = false 
        }, 1500);
    },
    submit(){
      if(this.commDesc ==''){
        this.showTipMessage(true, '请填写分享内容');
        return
      }else if(this.file.length < 1){
        this.showTipMessage(true, '请选择分享的图片');
        return;
      }else{
        let picIds = [];

        this.file.forEach(function(item, index) {
           picIds.push(item.fileId);
        });
        this.submitShareData([this.orderId,this.commDesc,picIds]).then(res =>{
          this.showTipMessage(true, '分享成功啦');
          setTimeout(() => { 
            this.$router.push({ path: '/' })
          }, 500);
        }).catch(err=>{
          this.showTipMessage(true, err ||'分享失败啦，待会试试吧！');
        })
      }
    },
    //浏览商品详情
    viewGoodsDetail(goods) {
      if (goods && goods.goodsId) {
        this.$router.push({
          path: '/main/goodsDetail?goodsId=' + goods.goodsId + '&skuId=' + (goods.skuId || 0)
        })
      }
    },
    // 选择图片
    selimg(action) { 
      let filetarget = '';
      let _this =this;
      filetarget = this.$refs.albumImg.files[0];
      if(!filetarget){
        return;
      }
      util.uploadImg(this.actionUrl,filetarget,'avatar').then(res=>{
        if(!res.returnTargets[0].fileId){
          return;
        }
        res.returnTargets[0].fileName = Constant.imgBaseUrl + '/image/'+ res.returnTargets[0].fileName;
        //存储上传的文件
        _this.file.push(res.returnTargets[0]);

      }).catch(err=>{
          this.showTipMessage(true, err);
      });   
    },
    //删除图片
    deletefile(id){
      let _this =this;
      _this.file.forEach(function(item, index) {
        if (item.fileId == id)
           _this.file.splice(item, 1);
      });
    }
  },
  watch: {},
  mounted() {
    //当前店铺订单详情
    this.listOrderGoodsMsgByOrderId(this.orderId).then(res => {
      this.memOrderDetailMsg = res;console.log(res)
      this.loadShow = false;
    }).catch(error => {
      console.log(error);
    });
  },
  components: {
    menus,
    myOrdersItem,
    imgs
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.sunhome-wrap{
  .grid-tip{
    @include font-dpr(12px);
    color: #a4a4a4;
    background: #fff7ea;
    .wid60{
      width: 60%;
      float: left;
    }
    .wid40{
      width: 40%;
      text-align: right;
    }
  }
  .goods-content{
    background: #fff;
    border-bottom: 0.2rem solid #f5f7f9;
    padding: 0.35rem;
    .banner-recommend {
      width: 100%;
      .swiper-slide {
        padding-top: 0rem;
      }
      .img-box {
        padding-right:0.25rem;
        .img {
          height: 2.0rem;
          width: 2.0rem;
          margin: 0 auto;
          overflow: hidden;
          text-align: center;
        }
      }
    }
  }
  .text-content {
    position: relative;
    background: #fff;
    border-bottom: 0.2rem solid #f5f7f9;
    textarea {
      line-height: 1.5;
      width: 100%;
      min-height: 3.5rem;
      padding: 0.3rem;
      background: #fff;
      border: 0;
      resize: none;
    }
    .text-count {
      position: absolute;
      bottom: 0.7rem;
      right: 0.7rem;
    }
  }
  .img-content{
    padding:0.16rem;
    .img-item:nth-child(3n){
      margin-right: 0%;
    }
    .img-item{
      width: 32%;
      height: 2rem;
      float: left;
      margin:0.1rem auto;
      margin-right: 2%;
      position: relative;
      .filter{
        opacity: 0.5;
        background:#000;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 10;
      }
      div{
        height: 2rem;
        overflow:hidden;
        img{
          width: 100%;
        }
      }
      
      .delete{
        background: url('/static/images/ic_delete14@3x.png') no-repeat;
        background-size:100% auto ;
        height: 0.4rem;
        width: 0.3rem;
        display: inline-block;
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
        z-index: 11;
      }
    }
    .add{
      background: url('/static/images/ic_add_pic@3x.png') no-repeat;
      background-size:  100% 100%;
      .file-button {
          font-size: 10px;
          opacity: 0;
          height: 1.6rem;
          width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// publishsunhome.vue?1701cfd7